import React, {useState} from 'react';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import {Autocomplete} from '@mui/material';
import PropTypes from 'prop-types';
import {validateEmail} from '../utility/validationUtil';

const EMAILS_LIMIT = 5;

const EmailChipsInput = (
    {
        values,
        onChange,
        onBlur,
        label,
        disabled
    }) => {
    const [inputValue, setInputValue] = useState('');

    const handleChange = (e, newValues) => {
        if (newValues.length > EMAILS_LIMIT) {
            return;
        }

        const validEmails = newValues
            .map(x => {
                if (typeof x === 'object') {
                    return x;
                }

                return validateEmail(x).isValid ? {email: x} : null;
            })
            .filter(x => x != null);

        onChange(validEmails);
    };

    const handleBlur = (e) => {
        if (values.length >= EMAILS_LIMIT) {
            setInputValue('');

            return;
        }

        const email = (e.target.value ?? inputValue ?? '').trim();

        if (!email || !validateEmail(email).isValid) {
            return;
        }

        onBlur(email);
        setInputValue('');
    };

    return (
        <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={values}
            limitTags={5}
            onChange={handleChange}
            onBlur={handleBlur}
            inputValue={inputValue}
            disabled={disabled}
            onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
            renderTags={(value, getTagProps) =>
                value.map((value, index) => (
                    <Chip
                        key={index}
                        label={value.email}
                        {...getTagProps({index})}
                    />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={label}
                    disabled={disabled}
                    type="email"
                    helperText={`Enter email addresses, pressing Enter after each one (max ${EMAILS_LIMIT} allowed).`}
                />
            )}
            sx={{
                '&.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input': {
                    minWidth: '40%',
                }
            }}
        />
    );
};

EmailChipsInput.defaultProps = {
    label: 'Enter emails',
    disabled: false,
};

EmailChipsInput.propTypes = {
    values: PropTypes.array,
    label: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    disabled: PropTypes.bool,
};

export default EmailChipsInput;
